import { Link } from 'react-router-dom';
import './About.css';

export default function About() {
  return (
    <main id="top">
      <section className="ab-hero">
        <div className="wrap-wide">
          <div className="grid">
            <div>
              <span className="eyebrow">About ATZ Solution</span>
              <h1>The expert partner behind your federal success.</h1>
              <p className="sub">ATZ Solution is an independent professional services firm helping small and mid-size American businesses register, certify, and compete in the federal marketplace. We turn a confusing, high-stakes process into a managed, predictable path.</p>
              <div className="hero-actions" style={{ display: 'flex', gap: '14px', marginTop: '32px', flexWrap: 'wrap' }}>
                <Link className="btn btn-primary" to="/contact-us/">Get in Touch <span className="arw">→</span></Link>
                <Link className="btn btn-ghost" to="/services/">Explore Services</Link>
              </div>
            </div>
            <div className="media">
              <img className="ph" src="/images/office-team.jpg" alt="Team / formal office — about photo" />
              <div className="fact"><b>100%</b><span>on-time delivery for DoD, DHS, USDA & VA</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="ab-stats">
        <div className="wrap-wide">
          <div className="ab-stat"><b>25<em>+</em></b><span>Expert consultants</span></div>
          <div className="ab-stat"><b>50<em>+</em></b><span>Happy customers</span></div>
          <div className="ab-stat"><b>150<em>+</em></b><span>Projects delivered</span></div>
          <div className="ab-stat"><b>100<em>%</em></b><span>Success rate</span></div>
        </div>
      </section>

      <section className="sec-pad">
        <div className="wrap-wide">
          <div className="sec-head">
            <span className="kicker-num">Who we are</span>
            <h2>A specialist firm built for the federal marketplace.</h2>
            <p className="lead">Founded by professionals with deep roots in IT and government contracting, ATZ Solution exists to remove the complexity that keeps capable businesses out of federal work.</p>
          </div>
          <div className="ab-two">
            <div className="ab-pan">
              <span className="iconwrap"><svg className="ico"><use href="#i-users" /></svg></span>
              <h3>Who we are</h3>
              <p>A multi-disciplinary team of registration, certification, and compliance specialists. We handle the federal paperwork end to end so business owners can focus on running and growing their companies.</p>
            </div>
            <div className="ab-pan">
              <span className="iconwrap"><svg className="ico"><use href="#i-target" /></svg></span>
              <h3>Why we exist</h3>
              <p>The federal process is confusing, time-consuming, and unforgiving of small errors. We exist to make it simple, accurate, and predictable — so more American small businesses can win the contracts they deserve.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-pad" style={{ background: 'var(--surface-2)', borderTop: '1px solid var(--rule)', borderBottom: '1px solid var(--rule)', paddingTop: '84px', paddingBottom: '84px' }}>
        <div className="wrap-wide">
          <div className="sec-head center">
            <span className="eyebrow center">What we stand for</span>
            <h2>Values that govern every engagement.</h2>
          </div>
          <div className="val-grid">
            <div className="val"><span className="iconwrap"><svg className="ico"><use href="#i-handshake" /></svg></span><h3>Long-term partnerships</h3><p>We are not a one-and-done filing service. We stay with you through renewals, recertifications, and growth.</p></div>
            <div className="val"><span className="iconwrap"><svg className="ico"><use href="#i-shield" /></svg></span><h3>Results-driven integrity</h3><p>Transparent scope, honest timelines, and work done right the first time — no shortcuts, no surprises.</p></div>
            <div className="val"><span className="iconwrap"><svg className="ico"><use href="#i-trophy" /></svg></span><h3>Measured by performance</h3><p>Our success is defined by yours: active registrations, approved certifications, and contracts won.</p></div>
          </div>
        </div>
      </section>

      <section className="sec-pad">
        <div className="wrap-wide">
          <div className="sec-head">
            <span className="kicker-num">Why choose ATZ</span>
            <h2>The right partner makes federal contracting simple.</h2>
          </div>
          <div className="why-list2">
            <div className="why-row"><span className="ic"><svg className="ico"><use href="#i-users" /></svg></span><div><h4>Multi-disciplinary specialists</h4><p>Registration, certification, proposals, and compliance expertise under one roof.</p></div></div>
            <div className="why-row"><span className="ic"><svg className="ico"><use href="#i-dollar" /></svg></span><div><h4>Cost-friendly & effective</h4><p>Flat, transparent pricing focused on outcomes — real value, not billable hours.</p></div></div>
            <div className="why-row"><span className="ic"><svg className="ico"><use href="#i-refresh" /></svg></span><div><h4>Ever-evolving</h4><p>We stay current with changing federal rules so your filings are always compliant.</p></div></div>
            <div className="why-row"><span className="ic"><svg className="ico"><use href="#i-handshake" /></svg></span><div><h4>Long-term partnership</h4><p>A dedicated team that grows with your business across every contract vehicle.</p></div></div>
          </div>
        </div>
      </section>

      <section className="finalcta" id="contact">
        <div className="wrap">
          <span className="starrow center" style={{ marginBottom: '24px' }}><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg></span>
          <img className="brand-logo" style={{ height: '60px', margin: '0 auto' }} src="/atz-logo-white.png" alt="ATZ Solution" />
          <span className="eyebrow">Let's work together</span>
          <h2>Ready to put an expert team behind your federal goals?</h2>
          <p>Tell us where you are and we'll map the exact path forward — registration, certification, and the contracts that follow.</p>
          <div className="hero-actions">
            <Link className="btn btn-light" to="/contact-us/">Contact Us <span className="arw">→</span></Link>
            <Link className="btn btn-red" to="/services/">Explore Services</Link>
          </div>
          <div className="call">Prefer to talk now? Call <b>(704) 459-8642</b> · Mon–Fri 9:00–6:00 ET</div>
        </div>
      </section>
    </main>
  );
}
